var map = {
	"./arrow-gray.svg": 3197,
	"./arrow-right-white.svg": 7978,
	"./arrow.svg": 439,
	"./calendar-light.svg": 4607,
	"./calendar.svg": 4701,
	"./close.svg": 7657,
	"./company.svg": 4764,
	"./config.svg": 3267,
	"./contact.svg": 2582,
	"./copy.svg": 6945,
	"./crm.svg": 4730,
	"./dashboard.svg": 9143,
	"./default.svg": 1681,
	"./delete-small-white.svg": 2823,
	"./delete-small.svg": 77,
	"./delete.svg": 5930,
	"./design.svg": 1343,
	"./edit.svg": 1870,
	"./filter.svg": 5782,
	"./image.svg": 870,
	"./loading.svg": 5677,
	"./logo.svg": 9468,
	"./logout.svg": 6082,
	"./order.svg": 44,
	"./pdf.svg": 8415,
	"./people.svg": 4510,
	"./plus-blue.svg": 2215,
	"./plus-circle.svg": 4741,
	"./plus-white.svg": 6430,
	"./product.svg": 6660,
	"./quote.svg": 5080,
	"./save-blue.svg": 2805,
	"./save-white.svg": 9634,
	"./send.svg": 3893,
	"./upload-small.svg": 3439,
	"./upload.svg": 6800,
	"./user.svg": 3352
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7970;